import React from "react";

const VisionMission = () => {
  return (
    <section className="py-12 md:px-[75px] px-6 bg-[#FFEDA9]">
      <div className="">
        {/* Our core values heading */}
        <h4 className="font-garamond-subheading  text-[#2C3075] font-normal text-[32px] leading-[100%] mb-8"
          style={{ fontSize: "32px", lineHeight: "100%" }}
       >
          Our core values
        </h4>

        {/* ===== Vision Row ===== */}
        <div className="grid grid-cols-1 md:mb-16 md:grid-cols-2 items-start gap-6">
          {/* Vision heading */}
          <div>
            <h3 className="font-generalsans-subheading text-[#2C3075] font-normal md:text-[56px] text-[32px] leading-[110%]" >
              Vision
            </h3>
          </div>

          {/* Vision description */}
          <div className="md:flex md:justify-end">
            <div className="w-full md:w-[744px] border-t border-[#2C3075] pt-4">
              <p className="font-generalsans-description text-[#2C3075] font-normal md:text-[20px] text-[14px] leading-[110%]">
                To be a beacon of hope and healing, transforming lives through compassionate,
                comprehensive, and evidence-based care.
              </p>
            </div>
          </div>
        </div>

        {/* ===== Mission Row ===== */}
        <div className="grid grid-cols-1 md:mb-16 md:grid-cols-2 items-start gap-6 mt-8">
          {/* Mission heading */}
          <div>
            <h3 className="font-generalsans-subheading text-[#2C3075] font-normal md:text-[56px] text-[32px] leading-[110%]">
              Mission
            </h3>
          </div>

          {/* Mission description (line breaks instead of dots) */}
          <div className="md:flex md:justify-end">
            <div className="w-full md:w-[744px] border-t border-[#2C3075] pt-4 space-y-2">
              <p className="font-generalsans-description text-[#2C3075] font-normal md:text-[20px] text-[14px] leading-[110%]">
                Provide a safe, inclusive, and supportive environment for recovery.
              </p>
              <p className="font-generalsans-description text-[#2C3075] font-normal md:text-[20px] text-[14px] leading-[110%]">
                Offer integrated treatment programs addressing physical, emotional, and psychological well-being.
              </p>
              <p className="font-generalsans-description text-[#2C3075] font-normal md:text-[20px] text-[14px] leading-[110%]">
                Empower individuals with skills, awareness, and resilience for long-term recovery.
              </p>
              <p className="font-generalsans-description text-[#2C3075] font-normal md:text-[20px] text-[14px] leading-[110%]">
                Raise awareness and reduce stigma around mental health and addiction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
